import { OBRoutes } from '@utils/apiRoutes';
import { useOBQuery } from './useOBQuery';
import { useApiUrl } from '@gemini/lux-ds-pms';
import { PracticeGalleryBffDTO } from '@utils/interfaces';

interface GalleryImagesProps {
  practiceId: string;
}

const useGetGalleryImages = ({ practiceId }: GalleryImagesProps) => {
  const url = useApiUrl(
    OBRoutes.GalleryImages,
    'ONLINEBOOKING_CLIENT_BFF_API_BASE_URL',
  )?.replace('##practiceId', practiceId);

  return useOBQuery<PracticeGalleryBffDTO>(url, {});
};

export default useGetGalleryImages;
